import { render, staticRenderFns } from "./CapacitySettings.vue?vue&type=template&id=0b82b5b8&scoped=true&"
import script from "./CapacitySettings.vue?vue&type=script&lang=js&"
export * from "./CapacitySettings.vue?vue&type=script&lang=js&"
import style0 from "./CapacitySettings.vue?vue&type=style&index=0&id=0b82b5b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b82b5b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b82b5b8')) {
      api.createRecord('0b82b5b8', component.options)
    } else {
      api.reload('0b82b5b8', component.options)
    }
    module.hot.accept("./CapacitySettings.vue?vue&type=template&id=0b82b5b8&scoped=true&", function () {
      api.rerender('0b82b5b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/CapacitySettings.vue"
export default component.exports